export var LicensingTier;
(function (LicensingTier) {
    LicensingTier["Core"] = "Core";
    LicensingTier["Enhanced"] = "Enhanced";
    LicensingTier["Enterprise"] = "Enterprise";
    LicensingTier["JusticeCloud"] = "Justice Cloud";
})(LicensingTier || (LicensingTier = {}));
